export default __webpack_public_path__ + "static/media/menu-secret.bf7f09cd.svg";